import { render, staticRenderFns } from "./CampoSelectBase.vue?vue&type=template&id=2157de39&scoped=true"
import script from "./CampoSelectBase.vue?vue&type=script&setup=true&lang=js"
export * from "./CampoSelectBase.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CampoSelectBase.vue?vue&type=style&index=0&id=2157de39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2157de39",
  null
  
)

export default component.exports